import { render } from "./Offices.vue?vue&type=template&id=b42daf10&scoped=true"
import script from "./Offices.vue?vue&type=script&lang=js"
export * from "./Offices.vue?vue&type=script&lang=js"

import "./Offices.vue?vue&type=style&index=0&id=b42daf10&scoped=true&lang=css"

import exportComponent from "/Users/mustafatofur/Desktop/Work/ProjectCountMap/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42daf10"]])

export default __exports__